import { __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { useRef, useEffect } from 'react';
import classNames from './../../external_lib/classnames/index.js';
import Highlighter from './../../external_lib/react-highlight-words/dist/main.js';
import HorizonModal from '../../base/HorizonModal/index.js';
import HorizonCarousel from '../../base/HorizonCarousel/index.js';
import HorizonButton from '../../base/HorizonButton/index.js';
import Cancel from '../../assets/icons/jsx/Cancel.js';
import Next from '../../assets/icons/jsx/Next.js';
import Previous from '../../assets/icons/jsx/Previous.js';
import img from '../../assets/icons/urbanpiper-logo.svg.js';
import styles from '../../components/sublayouts/PiperRewind/index.module.scss.js';
function PiperRewind(_a) {
  var _b;
  var _c = _a.className,
    className = _c === void 0 ? '' : _c,
    _d = _a.open,
    open = _d === void 0 ? false : _d,
    onClose = _a.onClose,
    _e = _a.data,
    data = _e === void 0 ? [] : _e,
    _f = _a.children,
    children = _f === void 0 ? null : _f,
    _g = _a.modalProps,
    modalProps = _g === void 0 ? {} : _g,
    _h = _a.carouselProps,
    carouselProps = _h === void 0 ? {} : _h;
  var carouselRef = useRef(null);
  useEffect(function () {
    if (!open) {
      handleReset();
    }
    if (open) {
      handleFocus();
    }
  }, [open]);
  var handleFocus = function () {
    if ((carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) && carouselRef.current.innerSlider) {
      var slidesList_1 = carouselRef.current.innerSlider.list.querySelector('.slick-track');
      setTimeout(function () {
        var slide = slidesList_1.querySelector('.slick-slide');
        slide.focus();
      }, 200);
    }
  };
  var handleReset = function () {
    if (carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) {
      setTimeout(function () {
        carouselRef.current.goTo(0, true);
      }, 500);
    }
  };
  var handleNext = function () {
    if (carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) {
      carouselRef.current.next();
    }
  };
  var handlePrevious = function () {
    if (carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) {
      carouselRef.current.prev();
    }
  };
  var generateSlides = function () {
    var slides = [];
    var Component = null;
    data.forEach(function (obj) {
      Component = slideTypes[obj.type];
      slides.push(React__default.createElement(Component, {
        data: obj
      }));
    });
    return slides;
  };
  return React__default.createElement(HorizonModal, __assign({
    open: open,
    footer: null,
    closable: false,
    onCancel: onClose,
    width: 1024,
    className: styles.horizonModal,
    classNames: {
      mask: styles.modalMask,
      content: styles.modalContent
    },
    centered: true
  }, modalProps), React__default.createElement("div", {
    className: "flex flex-row-reverse justify-between mb-3"
  }, React__default.createElement(HorizonButton, {
    onClick: onClose,
    className: styles.actionBtn,
    icon: React__default.createElement(Cancel, {
      className: styles.cancelIcon
    })
  }, "Close")), React__default.createElement(HorizonCarousel, __assign({
    carouselRef: carouselRef,
    className: classNames(styles.horizonCarousel, className)
  }, carouselProps), (data === null || data === void 0 ? void 0 : data.length) > 0 ? (_b = generateSlides()) === null || _b === void 0 ? void 0 : _b.map(function (item, i) {
    return React__default.createElement("div", {
      key: i
    }, item);
  }) : children), React__default.createElement(Actions, {
    onNext: handleNext,
    onPrev: handlePrevious
  }));
}
var Actions = function (_a) {
  var onNext = _a.onNext,
    onPrev = _a.onPrev;
  return React__default.createElement("div", {
    className: "flex flex-row-reverse justify-between mt-3"
  }, React__default.createElement("div", {
    className: classNames(styles.carouselActions, 'flex items-center gap-4')
  }, React__default.createElement(HorizonButton, {
    onClick: onPrev,
    className: classNames(styles.actionBtn, styles.arrows)
  }, React__default.createElement(Previous, null)), React__default.createElement(HorizonButton, {
    onClick: onNext,
    className: classNames(styles.actionBtn, styles.arrows)
  }, React__default.createElement(Next, null))));
};
var SlideContainer = function (_a) {
  var _b = _a.bgImg,
    bgImg = _b === void 0 ? '' : _b,
    _c = _a.type,
    type = _c === void 0 ? '' : _c,
    _d = _a.children,
    children = _d === void 0 ? null : _d,
    _e = _a.classes,
    classes = _e === void 0 ? '' : _e,
    _f = _a.style,
    style = _f === void 0 ? {} : _f;
  return React__default.createElement("div", {
    className: classNames(styles.slideContainer, styles === null || styles === void 0 ? void 0 : styles[type], classes),
    style: __assign(__assign({}, style !== null && style !== void 0 ? style : {}), bgImg ? {
      backgroundImage: "url(".concat(bgImg, ")"),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    } : {})
  }, children, React__default.createElement("img", {
    className: styles.upLogo,
    src: img,
    alt: "urbanpiper-logo"
  }));
};
var Headline = function (_a) {
  var _b;
  var _c = _a.data,
    data = _c === void 0 ? {} : _c;
  return React__default.createElement(SlideContainer, {
    bgImg: data === null || data === void 0 ? void 0 : data.bgImg,
    type: data === null || data === void 0 ? void 0 : data.type,
    classes: data === null || data === void 0 ? void 0 : data.containerClass,
    style: data === null || data === void 0 ? void 0 : data.containerStyle
  }, React__default.createElement("div", {
    className: classNames(styles.contentBox, data === null || data === void 0 ? void 0 : data.contentClass),
    style: __assign({}, (_b = data === null || data === void 0 ? void 0 : data.contentStyle) !== null && _b !== void 0 ? _b : {})
  }, data.content.map(function (obj, i) {
    return React__default.createElement("div", {
      key: i,
      className: styles[obj.variant]
    }, obj.text || '');
  }), (data === null || data === void 0 ? void 0 : data.topic) && React__default.createElement("div", {
    className: styles.topic
  }, data.topic)));
};
var Metrics = function (_a) {
  var _b;
  var _c = _a.data,
    data = _c === void 0 ? {} : _c;
  return React__default.createElement(SlideContainer, {
    bgImg: data === null || data === void 0 ? void 0 : data.bgImg,
    type: data === null || data === void 0 ? void 0 : data.type
  }, (data === null || data === void 0 ? void 0 : data.subTopic) && React__default.createElement("div", {
    className: styles.subTopic
  }, data.subTopic), React__default.createElement("div", {
    className: classNames(styles.contentBox, data === null || data === void 0 ? void 0 : data.contentClass),
    style: __assign({}, (_b = data === null || data === void 0 ? void 0 : data.contentStyle) !== null && _b !== void 0 ? _b : {})
  }, React__default.createElement("div", {
    className: classNames(styles.metricsWrapper, 'flex flex-col justify-center gap-16 p-11')
  }, data.metrics.map(function (metric, j) {
    return React__default.createElement(Metric, {
      key: j,
      metric: metric
    });
  }))), (data === null || data === void 0 ? void 0 : data.topic) && React__default.createElement("div", {
    className: styles.topic
  }, data.topic));
};
var Metric = function (_a) {
  var _b = _a.metric,
    metric = _b === void 0 ? {} : _b;
  return React__default.createElement("div", {
    className: styles.metricContainer
  }, React__default.createElement("div", {
    className: styles.metricIcon
  }, metric.icon), React__default.createElement("div", {
    className: styles.metricContent
  }, React__default.createElement("div", {
    className: styles.metricTitle
  }, metric.title), (metric === null || metric === void 0 ? void 0 : metric.highlight) ? React__default.createElement(Highlighter, {
    className: styles.metricText,
    highlightClassName: styles.highlight,
    searchWords: [metric.highlight],
    autoEscape: true,
    textToHighlight: metric.text || ''
  }) : React__default.createElement("div", {
    className: styles.metricText
  }, metric.text)));
};
var slideTypes = {
  headline: Headline,
  metrics: Metrics
};
export { Headline, Metric, Metrics, SlideContainer, PiperRewind as default, slideTypes };
//# sourceMappingURL=index.js.map
